import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://sso.jogjaprov.go.id',
  realm: 'aptika',
  clientId: 'webopd'
});

export default keycloak;
